import { Link, Text } from "mondrian-react";
import { logger } from "./logger";
import { reportGA4 } from "utils/pushDataLayer";
import { getCookie } from "./cookie";

export const ErrorFatura = (
  error,
  setDialogObject,
  setIsPhoneError,
  setLoading,
  setCurrentStep
) => {
  const isTotem = Boolean(getCookie('is-totem'));
  const messageCombo = isTotem 
    ? <>
        <Text body className="mdn-u-marginBottom--xs mdn-u-marginTop--xs">Como cliente Claro Multi você possui contratados os planos Móvel e Residencial.</Text>
        <Text body className="mdn-u-marginBottom--xs">Neste caso, procure nosso(a)s atendentes na loja para resolver a sua necessidade.</Text>
        <Text body className="mdn-u-marginBottom--xs">Você receberá a ajuda por essa equipe.</Text>
      </>
    : [
      "Identificamos que você é um cliente",
      <strong> Combo</strong>,
      ", para pagar sua fatura completa, acesse o Fatura Fácil - ",
      <Link onClick={()=>{logger({ name: "RedirectClaroResidencialFaturaFacil" }); }} href="https://minhaclaroresidencial.claro.com.br/fatura-facil">
        <strong> Minha Claro residencial.</strong>
      </Link>,
    ];

  const StatusCode = error.errorCode;
  setLoading(false);

  switch (StatusCode) {
    case "API-EASYINVOICES-003":
      setDialogObject({
        title: "Código de segurança 10",
        description: ["O Código de autorização é inválido."],
        function: () => {
          setDialogObject({
            title: "",
            description: "",
            function: () => {},
            isOpen: false,
          });
        },
        isOpen: true,
      });
      logger({ name: "ErrorInvalidoToken", error: StatusCode });
      reportGA4({
        event: "callback",
        customTitle: 'validacao_do_token',
        customCallback: 'erro'
      })
      break;
    case "MS-AA-EASTINVOICES-SERVICE-007":
      setDialogObject({
        title: "Fatura Fácil",
        botao: 'OK',
        description: messageCombo,
        function: () => {
          setDialogObject({
            title: "",
            description: [""],
            function: () => {},
            isOpen: false,
          });
        },
        isOpen: true,
      });
      logger({ name: "ErrorInvalidoToken", error: StatusCode });
      reportGA4({
        event: "callback",
        customTitle: 'validacao_do_token',
        customCallback: 'erro'
      })
      break;
    default:
      setIsPhoneError(true);
      setCurrentStep(0);
      setDialogObject({
        title: "",
        description: [""],
        function: () => {},
        isOpen: false,
      });
      logger({ name: "ErrorApiInvoices", error: StatusCode });
      reportGA4({
        event: "callback",
        customTitle: 'fatura',
        customCallback: 'erro:nao_foi_possivel_obter_as_faturas'
      })
      break;
  }
}
